module.exports = __webpack_public_path__ + "media/images/peb/8mm/peb_e-b79643154f4808536edd462aa70c98c6.png";